<app-mrpp-customer-ack-table></app-mrpp-customer-ack-table>
